export const offeringHttpRoutes = [
  {
    path: "/webhooks/twilio",
    method: "POST",
    accessLevel: "public",
    bypassRateLimit: true,
    requiredHeaders: [],
    proxy: {
      target: "http://127.0.0.1:8080",
      preservePath: true,
    },
  },
  {
    path: "/webhooks/telnyx",
    method: "POST",
    accessLevel: "public",
    bypassRateLimit: true,
    requiredHeaders: [],
    proxy: {
      target: "http://127.0.0.1:8080",
      preservePath: true,
    },
  },
];
